import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m17 2 4 4-4 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 11v-1a4 4 0 0 1 4-4h14" }),
		/* @__PURE__ */ _jsx("path", { d: "m7 22-4-4 4-4" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 13v1a4 4 0 0 1-4 4H3" })
	]
});
const ForwardRef = forwardRef(SvgRepeat);
export default ForwardRef;
